import { render, staticRenderFns } from "./BtnFullScren.vue?vue&type=template&id=da6b60ba&"
import script from "./BtnFullScren.vue?vue&type=script&lang=js&"
export * from "./BtnFullScren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports